import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-income-report',
  templateUrl: './income-report.component.html',
  styleUrls: ['./income-report.component.css']
})
export class IncomeReportComponent implements OnInit {

  public menu_item_id = '68';
  private dp = [];
  total = '0';

  displayedColumns = ['invoice_id', 'invoice_no', 'invoice_date', 'customer_name', 'invoice_type',
    'total', 'pay_status', 'payment_method', 'payment_date', 'paid_date', 'cc_name', 'sales_acct', 'view'];
  displayedColumns2 = ['invoice_id', 'invoice_no', 'invoice_date', 'customer_name', 'invoice_type',
    'total', 'pay_status', 'payment_method', 'payment_date', 'paid_date', 'cc_name', 'sales_acct'];
  dataSource = new MatTableDataSource(this.dp);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'from_date': new Date(), 'to_date': new Date(), 'invoice_type': 'all', 'payment_type_id': '0', 'customer_no': '',
    'user_name': 'all', 'branch_id': '0', 'cc_id': 'all', 'due_payment': '', 'title': 'تقرير الإيرادات'
  };

  search_obj = {
    'placeholder': 'اسم العميل/ رقم العميل/ رقم الجوال', 'class_name': 'midField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'condition': " AND `branch_id` = '" + this.model['branch_id'] + "'"
    }]
  };

  invoice_type = [{ 'value': 'all', 'type_name': 'الكل', 'type_name_en': 'All' },
    { 'value': 'invoice', 'type_name': 'فواتير المبيعات', 'type_name_en': 'Sales Invoices' },
    { 'value': 'return_invoice', 'type_name': 'مرتجع المبيعات', 'type_name_en': 'Return Sales Invoices' }];


  payment_type = [];
  customerList = [];
  users = [];
  branches = [];
  cost_center = [];
  branchList = [];
  //accounts = [];

  Income_Report; Customer_Placeholder; Sale_Invoice; Return_Sales_Invoices;
  Sale_Inv; Sales_Return; From_Date; To_Date; All; Paid;
  Unpaid; Amount_Total; Search_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Income_Report').subscribe((res: string) => {
      this.Income_Report = res;
    });
    this.model['title'] = this.Income_Report;

    translate.get('Customer_Placeholder').subscribe((res: string) => {
      this.Customer_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Customer_Placeholder;

    // translate.get('All').subscribe((res: string) => {
    //   this.All = res;
    // });
    // this.invoice_type['0']['type_name'] = this.All;

    // translate.get('Sale_Invoice').subscribe((res: string) => {
    //   this.Sale_Invoice = res;
    // });
    // this.invoice_type['1']['type_name'] = this.Sale_Invoice;

    // translate.get('Return_Sales_Invoices').subscribe((res: string) => {
    //   this.Return_Sales_Invoices = res;
    // });
    // this.invoice_type['2']['type_name'] = this.Return_Sales_Invoices;

    translate.get('Sale_Inv').subscribe((res: string) => {
      this.Sale_Inv = res;
    });

    translate.get('Sales_Return').subscribe((res: string) => {
      this.Sales_Return = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Paid').subscribe((res: string) => {
      this.Paid = res;
    });

    translate.get('Unpaid').subscribe((res: string) => {
      this.Unpaid = res;
    });

    translate.get('Amount_Total').subscribe((res: string) => {
      this.Amount_Total = res;
    });
    
    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });
  }

  ngOnInit() {
    let obj;

    let query = "SELECT * FROM `payment_type` WHERE `status`='1' AND `payment_type_key` != 'cobon'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.payment_type = data.data['list'];
        this.payment_type.unshift({ 'payment_type_id': '0', 'payment_type_name': 'الكل', 'payment_type_name_en': 'all' });
      });

    query = this.queryList.all_costCenter;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cost_center = data.data['list'];
        this.cost_center.unshift({ 'cc_id': '0', 'cc_name': 'الرئيسي', 'cc_name_en': 'cost_center' });
        this.cost_center.unshift({ 'cc_id': 'all', 'cc_name': 'الكل', 'cc_name_en': 'all' });
      });

    let condition = '';
    if (this.applicationConstants.user_info['user_name'] != 'mas')
      condition += " AND `user`.`user_name` != 'mas'";

    query = "SELECT `user`.`user_id`, `employee`.`name`, `employee`.`name_en`, `user`.`user_name`, `employee`.`employee_no`" +
      " FROM `user`, `employee` WHERE `user`.`status` = '1' AND `employee`.`employee_no` = `user`.`employee_no`" + condition;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        this.users = data.data['list'];
        this.users.unshift({ 'user_name': 'all', 'name': 'الكل', 'name_en': 'All' });
      });


    query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];

        if (this.branchList.length > 1) {
          let in_condition = "";
          this.search_obj.table_list[0]['condition'] = " AND `branch_id` IN (";

          this.branchList.forEach(element => {
            if (in_condition != "")
              in_condition += ",";
              in_condition += "' " + element.branch_id + "'";
          });
          this.search_obj.table_list[0]['condition'] += in_condition + ")";
        }
        else 
          this.search_obj.table_list[0]['condition'] = " AND `branch_id` = '" + this.branchList[0]['branch_id'] + "'";
      
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  // onChangeCustomer = function (acct_number: string) {
  //   // console.log(acct_number);
  //   this.model['customer_no'] = acct_number;
  // }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);
    this.model['customer_no'] = search_result['no'];
  }

  search() {
    this.dp = [];
    this.total = '0';

    if (this.model['from_date'] == undefined && this.model['to_date'] == undefined && 
      this.model['invoice_type'] == 'all' && this.model['payment_type_id'] == '0' && 
      this.model['user_name'] == 'all' && this.model['cc_id'] == 'all' && this.model['branch_id'] == '0' &&
      this.model['customer_no'] == '' && this.model['due_payment'] == '') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getIncomeReport' };

    if (this.model['from_date'] != undefined) 
      obj['from_date'] = this.model['from_date'].getFullYear() + "-" + 
        (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate() + ' 00:00:00';

    if (this.model['to_date'] != undefined) 
      obj['to_date'] = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + 
        "-" + this.model['to_date'].getDate() + ' 23:59:59';

    if (this.model['invoice_type'] != 'all')
      obj['invoice_type'] = this.model['invoice_type'];

    if (this.model['payment_type_id'] != '0')
      obj['payment_type_id'] = this.model['payment_type_id'];

    if (this.model['user_name'] != 'all')
      obj['user_name'] = this.model['user_name'];

    if (this.model['cc_id'] != 'all')
      obj['cc_id'] = this.model['cc_id'];

    if (this.model['branch_id'] != '0') 
      obj['branch_list'] = [{ 'branch_id':this.model['branch_id'] }];
    else 
      obj['branch_list'] = this.branchList;

    if (this.model['customer_no'] != '')
      obj['customer_no'] = this.model['customer_no'];

    if (this.model['due_payment'] != '')
      obj['due_payment'] = this.model['due_payment'];

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        console.log(data);
        if (data.status['type'] == 'success') {
          this.dp = data.status['msg'][0]['list'];
          this.total = data.status['msg'][0]['total'];
        }
        else
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }


  print() {
    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"><h2>' + this.Income_Report + '</h2></td></tr>';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Amount_Total + ': ' + this.total + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('incomes_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
